import React from 'react';
import { DATE_GROUP_GRANULARITIES, matrixConfigHasDateGroups } from './matrixDateGrouping';
import './MatrixReportTable.css';

/**
 * Month / quarter / year bucketing control for date fields used as report groups.
 */
const DateGroupGranularityBar = ({
  rowGroups = [],
  columnGroups = [],
  matrixDateGranularity = 'month',
  onMatrixDateGranularityChange,
  hint = 'Applies to all date row and column groups (e.g. Close Date → Mar 2026)',
}) => {
  if (!matrixConfigHasDateGroups(rowGroups, columnGroups)) {
    return null;
  }

  return (
    <div className="matrix-date-granularity-bar">
      <span className="matrix-date-granularity-label">Date grouping</span>
      <select
        className="matrix-date-granularity-select"
        value={matrixDateGranularity}
        onChange={(e) => onMatrixDateGranularityChange?.(e.target.value)}
        title="How date fields are bucketed when grouped"
      >
        {DATE_GROUP_GRANULARITIES.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <span className="matrix-date-granularity-hint">{hint}</span>
    </div>
  );
};

export default DateGroupGranularityBar;
